import(/* webpackMode: "eager" */ "/Users/martina/Desktop/Project/template-0213/app/global-error.tsx");
